import { getLink } from "../../../utils/utils";

import translator from "./translator";

const cite1Text = `
 Lanĵerono, Moldavanka, Peresip, Fontanoj – distriktoj de Odessa, <br/>
 Privozo – plej granda bazaro, <br/>
 Ponto kaj Kanono – komenco kaj fino de l’ Primorskij bulvardo. <br/>
`;

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Nigras maro. <br/>
        Kaj la luno pendas super Lanĵerono. <br/>
        La bulvardo <br/>
        Sternas sin inter la Ponto kaj l’ Kanono. <br/>
        Lum’ arĝenta <br/>
        Kolorigas la kaŝtanojn sur la stratoj. <br/>
        Dormas dolĉe <br/>
        La Fontanoj, strandoj, fiŝoj kaj boatoj.
      </p>

      <p class="poem-block mb-3">
        De l’ Bulvardo <br/>
        Ŝtuparego vin kondukos al haveno. <br/>
        En la parko <br/>
        Pridiskutas oni ĉion dum promeno: <br/>
        Bapojn, nuptojn <br/>
        Kaj abortojn, sen skrupul’ kaj sen sekretoj. <br/>
        En kafejoj <br/>
        Drinkas kune komercistoj kaj poetoj.
      </p>

      <p class="poem-block mb-3">
        Ne imagu <br/>
        Vi Odeson sen Privozo kaj bazaroj, <br/>
        Tie svarmas <br/>
        Buntaj hordoj kaj vendeblas buntaj varoj. <br/>
        Okulfrapas <br/>
        Riĉaj fruktoj de l’ abunda suda tero. <br/>
        Sur la plaĝoj <br/>
        Sama svarmo kaj delicoj de l’ somero.
      </p>
      
      <p class="poem-block refreno mb-3">
        En haveno <br/>
        Venas ŝipoj kaj kliniĝas pene gruoj, <br/>
        Krias mevoj <br/>
        Super ondoj ŝaŭmantaj kaj helbluaj. <br/>
        Mara vento <br/>
        Portas kanton pri amata kaj karesa, <br/>
        La superba <br/>
        Kaj por ĉiam kara belulin’ Odessa.
      </p>

      <p class="poem-block mb-3">
        Eksterlande <br/>
        Mi vin sonĝas kaj pri vi sopiras kore, <br/>
        Moldavanka <br/>
        Kaj Peresip vekiĝantaj por laboro. <br/>
        La pavimoj <br/>
        En matena lum’ brilantaj post akvumo… <br/>
        Brilas suno, <br/>
        Kaj plenigas l’ urbon ĉi fabela lumo.
      </p>

      <ol class="cites mb-3">
        <li>
          ${cite1Text}
        </li>
      </ol>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kanto pri Odeso'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['N3kjUJKgE0k'],
    itemTranslator: `
      muziko kaj teksto de E. Kriĉmar.<br/>
      ${translator.esp}
    `
  }
}

export default item;